/* eslint-disable */
import React from "react";
// import UserStore from "./User";
import CompanyStore from "./Company";
// import PermissionStore from "./Permission";
// import BreadcrumbStore from "./Breadcrumb";
import PayerStore from "./Payer";
import MiscStore from "./Misc";
import PDFStore from "./PDF";
import ConversionRatesStore from "./ConversionRates";

const RootStore = {
  // user: new UserStore(),
  company: new CompanyStore(),
  payer: new PayerStore(),
  misc: new MiscStore(),
  pdf: new PDFStore(),
  conversionRates: new ConversionRatesStore(),
  // permission: new PermissionStore(),
  // breadcrumb: new BreadcrumbStore(),
};

const RootContext = React.createContext<typeof RootStore>(RootStore);

const useRootStore = (): typeof RootStore => React.useContext(RootContext);

export default function getRootStore(): typeof RootStore {
  return useRootStore();
}

export { RootStore, RootContext, getRootStore, useRootStore };
